module.exports = __webpack_public_path__ + "img/StakingEquation1.3110f270.png";